/**
 * Structured incident reports for Images Bulk Upload support pastes
 * @module services/images/bulk-upload-incident
 */

export const BULK_UPLOAD_FEATURE = 'images-bulk-upload'

export const BULK_UPLOAD_STAGE_FILE_READ = 'file-read'
export const BULK_UPLOAD_STAGE_CONTENT_LOOKUP = 'content-lookup'
export const BULK_UPLOAD_STAGE_CREATE = 'create'

/**
 * Create a batch id shared across one drop or publish run
 * @returns {String}
 */
export function createBulkUploadBatchId () {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
}

/**
 * Build a structured incident report for a single failed image
 * @param {Object} params
 * @returns {Object}
 */
export function createBulkUploadIncidentReport ({
  batchId,
  fileName,
  itemId,
  stage,
  urlPresent,
  urlLength,
  httpStatus,
  brooklynDetail,
  message,
  batchSize,
  attempt = 0,
} = {}) {
  return {
    feature: BULK_UPLOAD_FEATURE,
    batchId: batchId || null,
    fileName: fileName || null,
    itemId: itemId || null,
    stage: stage || null,
    urlPresent: Boolean(urlPresent),
    urlLength: typeof urlLength === 'number' ? urlLength : 0,
    httpStatus: httpStatus == null ? null : httpStatus,
    brooklynDetail: brooklynDetail || null,
    message: message || null,
    batchSize: typeof batchSize === 'number' ? batchSize : null,
    attempt,
    retriesApplied: false,
    time: new Date().toISOString(),
  }
}

/**
 * Format an incident report as pasteable text for Admin App support
 * @param {Object} report
 * @returns {String}
 */
export function formatBulkUploadIncidentReportForSupport (report = {}) {
  const lines = [
    `--- Friendly Admin App Support / ${report.feature || BULK_UPLOAD_FEATURE} ---`,
    `batchId: ${report.batchId ?? ''}`,
    `file: ${report.fileName ?? ''}`,
    `itemId: ${report.itemId ?? ''}`,
    `stage: ${report.stage ?? ''}`,
    `urlPresent: ${report.urlPresent ? 'true' : 'false'}`,
    `urlLength: ${report.urlLength ?? 0}`,
    `httpStatus: ${report.httpStatus == null ? '' : report.httpStatus}`,
    `brooklynDetail: ${report.brooklynDetail ?? ''}`,
    `message: ${report.message ?? ''}`,
    `batchSize: ${report.batchSize == null ? '' : report.batchSize}`,
    `attempt: ${report.attempt ?? 0}`,
    `retriesApplied: ${report.retriesApplied ? 'true' : 'false'}`,
    `time: ${report.time ?? ''}`,
    '---',
  ]
  return lines.join('\n')
}

/**
 * Log a report for DevTools users and return the formatted paste string
 * @param {Object} report
 * @returns {String}
 */
export function logBulkUploadIncident (report) {
  const formatted = formatBulkUploadIncidentReportForSupport(report)
  // eslint-disable-next-line no-console
  console.error(report, formatted)
  return formatted
}
